import { supabase } from "@/integrations/supabase/client";
import { guestKnowledgeContent } from "@/lib/guestGuideCopy";

/** Push create/update/delete to Hospitable Knowledge Hub. Soft-fails so local save still wins. */
export async function syncGuestGuideKnowledge(input: {
  propertyId: string;
  source: "inventory" | "appliance";
  itemId: string;
  content?: string | null;
}) {
  try {
    const { error } = await supabase.functions.invoke("hospitable-proxy", {
      body: {
        action: "sync_guest_guide",
        property_id: input.propertyId,
        source: input.source,
        item_id: input.itemId,
        ...(input.content ? { content: guestKnowledgeContent(input.content) } : {}),
      },
    });
    if (error) console.error("[syncGuestGuideKnowledge]", error);
  } catch (e) {
    console.error("[syncGuestGuideKnowledge]", e);
  }
}

/** Delete a Knowledge Hub item when the inventory/appliance row is being removed. */
export async function deleteGuestGuideKnowledge(input: {
  propertyId: string;
  knowledgeItemId: string | null | undefined;
}) {
  const knowledgeItemId = (input.knowledgeItemId || "").trim();
  if (!knowledgeItemId) return;
  try {
    const { error } = await supabase.functions.invoke("hospitable-proxy", {
      body: {
        action: "delete_guest_guide_knowledge",
        property_id: input.propertyId,
        knowledge_item_id: knowledgeItemId,
      },
    });
    if (error) console.error("[deleteGuestGuideKnowledge]", error);
  } catch (e) {
    console.error("[deleteGuestGuideKnowledge]", e);
  }
}
